import { deploymentsApi } from '../api/deploymentsApi';
import { deploymentQueryKey } from './useDeployment';
import {
  useDeploymentMutation,
  type DeploymentMutationOptions,
} from './_deploymentMutations';

export const useImportDeploymentItems = (
  deploymentId: string,
  options: DeploymentMutationOptions<{ inserted: number }> = {}
) =>
  useDeploymentMutation<unknown[], { inserted: number }>({
    mutationFn: (items) => deploymentsApi.importItems(deploymentId, items),
    invalidate: (qc) =>
      qc.invalidateQueries({ queryKey: deploymentQueryKey(deploymentId) }),
    errorLabel: 'Error importing items',
    ...options,
  });
